/* ===================================================================
   MOMENTUM BIJOUX — GLOBAL SCRIPT  (momentum-global.js)
   One consolidated script for every template. Each block is guarded
   so it only runs when its elements are present on the page.
   =================================================================== */
(function () {
  'use strict';

  /* ---------- Mobile drawer (all pages) ---------- */
  function initDrawer() {
    if (window.__mbDrawerReady) return;
    window.__mbDrawerReady = true;

    // Move the drawer to <body> so position:fixed is relative to the viewport,
    // not trapped inside the sticky / backdrop-filtered header section.
    var dr = document.getElementById('drawer');
    if (dr && dr.parentNode !== document.body) document.body.appendChild(dr);

    function getDrawer() { return document.getElementById('drawer'); }
    function getBurger() { return document.getElementById('burger'); }
    function open() {
      var d = getDrawer(); if (!d) return;
      d.classList.add('open');
      document.body.classList.add('lock');
      var b = getBurger(); if (b) b.setAttribute('aria-expanded', 'true');
    }
    function close() {
      var d = getDrawer(); if (!d) return;
      d.classList.remove('open');
      document.body.classList.remove('lock');
      var b = getBurger(); if (b) b.setAttribute('aria-expanded', 'false');
    }

    // Capture phase + delegated: fires before anything can swallow the click,
    // and survives Horizon section re-renders / soft navigation.
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('#burger, .burger')) { e.preventDefault(); e.stopPropagation(); open(); return; }
      if (t.closest('#drawer [data-close]')) { e.preventDefault(); close(); return; }
      if (t.closest('#drawer .d-link, #drawer .d-chips a, #drawer .d-foot a')) { close(); }
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    }, true);
  }

  /* ---------- Scroll reveal (all pages) ---------- */
  function initReveal() {
    var nodes = document.querySelectorAll('.reveal');
    if (!nodes.length || !('IntersectionObserver' in window)) {
      nodes.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (x) {
        if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); }
      });
    }, { threshold: 0.12 });
    nodes.forEach(function (el, i) {
      el.style.transitionDelay = (i % 4 * 60) + 'ms';
      io.observe(el);
    });
  }

  /* ---------- Collection: filter chips ---------- */
  function initCollectionChips() {
    var chips = document.querySelectorAll('.chip');
    if (!chips.length) return;
    chips.forEach(function (c) {
      c.onclick = function () {
        chips.forEach(function (x) { x.classList.remove('on'); });
        c.classList.add('on');
      };
    });
  }

  /* ---------- Cart: quantity + remove ---------- */
  function initCart() {
    document.querySelectorAll('.rm').forEach(function (r) {
      r.onclick = function () {
        var line = r.closest('.line');
        if (line) line.style.opacity = 0.4;
        r.textContent = 'Removed';
      };
    });
  }
  // global: used by cart inline onclick="q(this,1)"
  window.q = function (btn, d) {
    var i = btn.parentElement.querySelector('input');
    if (i) i.value = Math.max(1, parseInt(i.value, 10) + d);
  };

  /* ---------- Product gallery (necklace + tshirt share .gthumbs) ---------- */
  function initGallery() {
    var thumbs = document.querySelectorAll('.gthumbs button');
    if (!thumbs.length) return;
    var imgs = Array.prototype.map.call(thumbs, function (b) { return b.innerHTML; });
    thumbs.forEach(function (b) {
      b.onclick = function () {
        thumbs.forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        var main = document.getElementById('gmain-img');
        if (main) main.innerHTML = imgs[b.dataset.i];
        var sticky = document.getElementById('sticky-img');
        if (sticky) sticky.innerHTML = imgs[b.dataset.i];
      };
    });
  }

  /* ---------- Product: real Shopify variant selection ---------- */
  function initProductVariants() {
    var idInput = document.getElementById('variant-id');
    function setPrices(price, compare, onsale) {
      var el;
      if ((el = document.getElementById('price-now'))) el.textContent = price;
      if ((el = document.getElementById('price-was'))) { el.textContent = compare; el.style.display = onsale ? '' : 'none'; }
      if ((el = document.getElementById('atc-price'))) el.textContent = price;
      if ((el = document.getElementById('sticky-price'))) el.textContent = price;
    }

    // Dropdown mode (used when there are more than 3 variants)
    var sel = document.getElementById('variant-select');
    if (sel) {
      function applyOption(o) {
        if (!o) return;
        if (idInput) idInput.value = o.value;
        setPrices(o.dataset.price, o.dataset.compare, o.dataset.onsale === '1');
      }
      sel.addEventListener('change', function () { applyOption(sel.options[sel.selectedIndex]); });
      applyOption(sel.options[sel.selectedIndex]); // sync on load
      return;
    }

    // Card mode (3 or fewer variants)
    var variants = document.querySelectorAll('.variant[data-vid]');
    if (!variants.length) return;
    function apply(v) {
      variants.forEach(function (x) { x.classList.remove('on'); });
      v.classList.add('on');
      if (idInput) idInput.value = v.dataset.vid;
      setPrices(v.dataset.price, v.dataset.compare, v.dataset.onsale === '1');
    }
    variants.forEach(function (v) {
      v.addEventListener('click', function () {
        if (v.dataset.available === 'false') return;
        apply(v);
      });
    });
  }

  // global: quantity stepper (updates the real form quantity input)
  window.stepQ = function (d) {
    var qty = document.getElementById('qty');
    if (!qty) return;
    var val = Math.max(1, (parseInt(qty.value, 10) || 1) + d);
    qty.value = val;
  };

  function initProductExtras() {
    var pdp = document.querySelector('.pdp');
    if (!pdp) return;
    // countdown — counts down to the product's sale-end datetime metafield
    var cd = document.getElementById('countdown');
    if (cd) {
      var endTs = cd.dataset.ends ? new Date(cd.dataset.ends).getTime() : 0;
      var setCD = function (id, v) { var el = document.getElementById(id); if (el) el.textContent = String(v).padStart(2, '0'); };
      var tickCD = function () {
        var total = endTs ? Math.max(0, Math.floor((endTs - Date.now()) / 1000)) : 0;
        setCD('cd-h', Math.floor(total / 3600)); setCD('cd-m', Math.floor(total % 3600 / 60)); setCD('cd-s', total % 60);
      };
      tickCD(); setInterval(tickCD, 1000);
    }
    // live viewer flicker (necklace .live / tshirt .livetxt)
    var live = document.querySelector('.live');
    if (live && live.childNodes[1]) {
      var m0 = (live.childNodes[1].textContent || '').match(/\d+/);
      var liveBase = m0 ? parseInt(m0[0], 10) : 24;
      setInterval(function () {
        var n = Math.max(2, liveBase + Math.floor(Math.random() * 5) - 2);
        live.childNodes[1].textContent = n + ' people are viewing this right now';
      }, 5000);
    }
    var livetxt = document.querySelector('.livetxt');
    if (livetxt) {
      setInterval(function () {
        var n = 22 + Math.floor(Math.random() * 18);
        livetxt.textContent = n + ' people have this in their cart';
      }, 4000);
    }
    // sticky add-to-cart bar
    var sb = document.getElementById('stickybar');
    if (sb) {
      var threshold = 600;
      window.addEventListener('scroll', function () {
        sb.classList.toggle('show', window.scrollY > threshold);
      });
    }
  }

  /* ---------- Search modal (Horizon-style, with predictive results) ---------- */
  function initSearchModal() {
    var modal = document.getElementById('searchModal');
    if (!modal) return;
    var input = document.getElementById('searchInput');
    var results = document.getElementById('searchResults');
    var openers = document.querySelectorAll('[data-search-open]');

    function open() {
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lock');
      setTimeout(function () { if (input) input.focus(); }, 80);
    }
    function close() {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lock');
    }
    openers.forEach(function (b) { b.addEventListener('click', open); });
    modal.querySelectorAll('[data-search-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('open')) close();
    });

    // Predictive search via Shopify Search Suggest API
    var timer = null;
    function money(cents) {
      try { return '$' + (parseInt(cents, 10) / 100).toFixed(2); } catch (e) { return ''; }
    }
    function render(data, term) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      var html = '';
      if (!products.length) {
        html = '<div class="sr-empty">No matches yet — keep typing, or press Enter to search.</div>';
      } else {
        html = '<div class="sr-head">Products</div><div class="sr-grid">';
        products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          var price = p.price ? money(p.price) : '';
          html += '<a class="sr-item" href="' + p.url + '">' +
            (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
            '<div><div class="sr-t">' + p.title + '</div>' +
            (price ? '<div class="sr-p">' + price + '</div>' : '') + '</div></a>';
        });
        html += '</div>';
        html += '<a class="sr-all" href="' + (window.routes && window.routes.search_url ? window.routes.search_url : '/search') +
          '?q=' + encodeURIComponent(term) + '">See all results →</a>';
      }
      results.innerHTML = html;
    }
    if (input) {
      input.addEventListener('input', function () {
        var term = input.value.trim();
        clearTimeout(timer);
        if (term.length < 2) { results.innerHTML = ''; return; }
        timer = setTimeout(function () {
          var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
            '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
          fetch(url, { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (d) { render(d, term); })
            .catch(function () { results.innerHTML = '<div class="sr-empty">Press Enter to search.</div>'; });
        }, 220);
      });
    }
  }

  /* ---------- boot ---------- */
  function boot() {
    initDrawer();
    initReveal();
    initSearchModal();
    initCollectionChips();
    initCart();
    initGallery();
    initProductVariants();
    initProductExtras();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
